<ng-container *ngIf="steps && verificationStatus">
    <app-card-info-steps
        infoTitle="Verificação de Conta"
        infoDescription="Verifique seu email e telefone para aumentar a segurança da sua conta."
        progressLabel="Verificação"
        [steps]="steps"
        [compact]="true"
        color="#F35D82">

        <!-- Email Verification Step -->
        <app-config-step
            title="Verificar Email"
            key="email_verified"
            [isComplete]="!!steps.email_verified"
            [skipTitle]="steps.email_verified ? 'Verificado' : 'Verificar'"
            (onAction)="openVerificationDialog()"
            (onSkip)="openVerificationDialog()"
            color="#F35D82">
        </app-config-step>

        <!-- Phone Verification Step -->
        <app-config-step
            title="Verificar Telefone"
            key="phone_verified"
            [isComplete]="!!steps.phone_verified"
            [skipTitle]="steps.phone_verified ? 'Verificado' : 'Verificar'"
            (onAction)="openVerificationDialog()"
            (onSkip)="openVerificationDialog()"
            color="#F35D82">
        </app-config-step>

        <!-- Company Profile Step -->
        <app-config-step
            title="Dados da Empresa"
            key="company_profile_completed"
            [isComplete]="!!steps.company_profile_completed"
            [skipTitle]="steps.company_profile_completed ? 'Preenchido' : 'Preencher'"
            (onAction)="openCompanyProfileDialog()"
            (onSkip)="openCompanyProfileDialog()"
            color="#F35D82">
        </app-config-step>

    </app-card-info-steps>
</ng-container>

<ng-container *ngIf="loading">
    <div class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</ng-container>
